import { put } from 'typed-redux-saga';

import { clearNotifications } from '../../../../shared/features/notifications/ps-notifications';
import { ConferenceStatus } from '../../constants';
import { setConferenceStatus } from '../../features/conference/slice';
import { networkStateOnline } from '../../features/offline/slice';
import { stopRecordConferenceAction } from '../../features/record';

export function* handleDisconnect() {
    yield put(setConferenceStatus(ConferenceStatus.DISCONNECTED));
    yield put(networkStateOnline());
    yield put(clearNotifications());
    yield put(stopRecordConferenceAction({ reason: 'kicked' }));
}
